import {Vue} from "ui.vue";
import VueGtag from "../node_modules/vue-gtag/dist/vue-gtag.umd.min";
import {VueYandexMetrika} from './vue-yandex-metrika/index';

console.log();

Vue.use(VueGtag, {
	config: {
		id: process.env.GA_ID
	}
});

export {VueYandexMetrika as YandexMetrika};
export default {VueYandexMetrika};